const DetailsFactureData = [
    {
        id: 1,
        libelle_soin: 'Achat de médicaments',
        prestataire: 'Pharmacie de la Liberté',
        beneficiaire: 'Sadio Sangharé',
        numero_contrat: '123456',
        cout: 12000,
        montant_rembourse: 9000,
        montant_retenu: 3000,
        date: '23-11-2020',
        fournisseur: 'Ceerno Lô',
        entreprise: 'Volkeno'
    },
    {
        id: 2,
        libelle_soin: 'Achat de médicaments',
        prestataire: 'Pharmacie de la Liberté',
        beneficiaire: 'Sadio Sangharé',
        numero_contrat: '123456',
        cout: 12000,
        montant_rembourse: 9000,
        montant_retenu: 3000,
        date: '23-11-2020',
        fournisseur: 'Ceerno Lô',
        entreprise: 'Volkeno'
    },
    {
        id: 3,
        libelle_soin: 'Achat de médicaments',
        prestataire: 'Pharmacie de la Liberté',
        beneficiaire: 'Sadio Sangharé',
        numero_contrat: '123456',
        cout: 12000,
        montant_rembourse: 9000,
        montant_retenu: 3000,
        date: '23-11-2020',
        fournisseur: 'Ceerno Lô',
        entreprise: 'Volkeno'
    },
    {
        id: 4,
        libelle_soin: 'Achat de médicaments',
        prestataire: 'Pharmacie de la Liberté',
        beneficiaire: 'Sadio Sangharé',
        numero_contrat: '123456',
        cout: 12000,
        montant_rembourse: 9000,
        montant_retenu: 3000,
        date: '23-11-2020',
        fournisseur: 'Ceerno Lô',
        entreprise: 'Volkeno'
    },
];

export default DetailsFactureData;
